import '../shared';

import { mountSimulator } from './mountSimulator';

const mapping = {
  '/': 'Simulation - Step 0.1',
  '/step-2': 'Simulation - Step 0.2',
  '/step-3': 'Simulation - Step 0.3',
  '/step-4': 'Simulation - Step 0.4',
  '/step-5': 'Simulation - Step 1',
  '/step-6': 'Simulation - Step 2',
  '/step-7': 'Simulation - Step 3',
  '/step-8': 'Simulation - Step 4',
};

const onLocationChange = (pathname) => {
  window.dataLayer.push({
    event: 'lead-simulation-analytics',
    'leads-simulation-step': mapping?.[pathname] ?? pathname,
  });
};

mountSimulator(
  () => import(/* webpackChunkName: "simulator-bpal" */ '@cozynergy/simulateur-bpal'),
  (props) => ({
    apis: props.apis,
    storeGroup: props.storeGroup,
    homeUrl: props.homeUrl,
    onLocationChange,
    basename: window.location.pathname,
    defaultValues: props.defaultValues,
  })
);
